<div class="result" *ngIf="result" [class.active]="active" (mouseenter)="activate()" (click)="rowClicked()" [class.disabled]="disabled">
  <p>{{ result.name }}</p>
</div>
